import * as React from "react";
import { Link } from "@/components/common/Link";
import { ArrowUpRight, X } from "lucide-react";
const portfolioItems = [{
  id: "1",
  title: "Melting Forest: Yeti Campaign",
  description: "Ai video commercial demonstrating fluid physics and character consistency for the modern beverage industry.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/IMG_0976.jpeg?v=wyfyp65fn5l",
  link: "/portfolio/yeti-campaign",
  aspectRatio: "aspect-[4/5]",
  videoUrl: "https://aicommercials.ai/wp-content/uploads/2026/06/Finished.mp4"
}, {
  id: "2",
  title: "Coming Soon",
  description: "Dynamic fashion showcase utilizing neural style transfer for high-impact social media presence.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/IMG_0979.jpeg?v=maqa5l0cxoq",
  link: "/portfolio/cyberpunk-streetwear",
  aspectRatio: "aspect-square",
  videoUrl: "https://www.youtube.com/shorts/dQw4w9WgXcQ"
}, {
  id: "3",
  title: "Coming Soon",
  description: "Abstract visual storytelling for luxury brands using generative particle simulations.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/IMG_0995.jpeg?v=hugp06ck80h",
  link: "/portfolio/ethereal-fragrance",
  aspectRatio: "aspect-[3/4]",
  videoUrl: "https://www.youtube.com/shorts/dQw4w9WgXcQ"
}, {
  id: "4",
  title: "Coming Soon",
  description: "High-octane beverage commercial with synchronized AI-generated motion graphics.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/2.jpg?v=4tt3isr20t9",
  link: "/portfolio/neon-pulse",
  aspectRatio: "aspect-video",
  videoUrl: "https://www.youtube.com/shorts/dQw4w9WgXcQ"
}, {
  id: "5",
  title: "Coming Soon",
  description: "Hyper-realistic interior design walkthroughs powered by advanced diffusion models.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/IMG_0974.jpeg?v=lgjwu694di",
  link: "/portfolio/architectural-dreams",
  aspectRatio: "aspect-[4/5]",
  videoUrl: "https://www.youtube.com/shorts/dQw4w9WgXcQ"
}, {
  id: "6",
  title: "Coming Soon",
  description: "Cinematic event teaser blending real footage with futuristic AI overlays.",
  image: "https://aicommercials.ai/wp-content/uploads/2026/04/IMG_0988.jpeg?v=2yazyynq9un",
  link: "/portfolio/future-tech",
  aspectRatio: "aspect-square",
  videoUrl: "https://www.youtube.com/shorts/dQw4w9WgXcQ"
}];
function VideoModal({
  videoUrl,
  onClose
}: {
  videoUrl: string;
  onClose: () => void;
}) {
  const getYoutubeId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };
  const isYoutube = videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
  const videoId = isYoutube ? getYoutubeId(videoUrl) : null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md p-4" onClick={onClose}>
      <div className="relative w-full max-w-[400px] aspect-[9/16] bg-black rounded-2xl overflow-hidden shadow-2xl border border-white/10" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 rounded-lg bg-black/50 text-white hover:bg-black/80 transition-colors">
          <X className="size-6" />
        </button>
        {isYoutube ? videoId ? <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`} className="w-full h-full" allow="autoplay; encrypted-media" allowFullScreen /> : <div className="w-full h-full flex items-center justify-center text-white font-mono">
              Video not found
            </div> : <video src={videoUrl} className="w-full h-full object-cover" controls autoPlay muted loop />}
      </div>
    </div>;
}
export default function Portfolio() {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState<typeof portfolioItems[0] | null>(null);
  const handleOpenModal = (item: typeof portfolioItems[0]) => {
    setActiveItem(item);
    setIsModalOpen(true);
  };
  return <section data-section-id="227748" id="viral-vision-gallery" className="bg-background bg-grid text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight mb-6 text-foreground">
              View Our Works
            </h2>
            <p className="font-mono text-lg text-muted-foreground">
              Cinematic AI video productions engineered for social dominance. We blend advanced neural synthesis with high-end film aesthetics to stop the scroll.
            </p>
          </div>
          <Link to="#" className="inline-flex items-center gap-2 font-default text-sm font-medium text-primary hover:text-secondary transition-colors">
            View all productions <ArrowUpRight className="size-4" />
          </Link>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
          {portfolioItems.map((item, i) => <div key={item.id} data-index={i} onClick={() => i === 0 && handleOpenModal(item)} className="break-inside-avoid mb-6 relative group rounded-3xl overflow-hidden bg-card/40 border border-primary/20 backdrop-blur-sm cursor-pointer">
              <div className="block w-full h-full">
                <div className={`relative w-full ${item.aspectRatio} overflow-hidden`}>
                  <img src={item.image} data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} alt={item.title} className="w-full h-full object-cover" loading="lazy" />

                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-90 !p-0" />

                  <div className="absolute inset-x-4 bottom-4 p-5 rounded-2xl bg-background/40 backdrop-blur-xl border border-primary/20 text-foreground flex flex-col justify-end transform transition-all duration-300">
                    <div className="flex items-start justify-between gap-4">
                      <h3 className="font-default text-xl font-semibold leading-tight text-foreground">
                        {item.title}
                      </h3>
                      <div className="size-8 rounded-lg bg-primary/20 flex items-center justify-center shrink-0 opacity-0 -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 delay-100">
                        <ArrowUpRight className="size-4 text-primary" />
                      </div>
                    </div>

                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-300 ease-in-out">
                      <p className="overflow-hidden font-mono text-xs text-muted-foreground mt-0 group-hover:mt-3 transition-all duration-300">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {isModalOpen && activeItem && <VideoModal videoUrl={activeItem.videoUrl} onClose={() => {
      setIsModalOpen(false);
      setActiveItem(null);
    }} />}
    </section>;
}